const AiChatMini = ({
  size = 20
}: {
  size?: number;
}) => {
  return <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="AiChatMini" data-sentry-source-file="ai_chat_mini.tsx">
      <path d="M14.1666 1.66663H5.83329C4.91282 1.66663 4.16663 2.41282 4.16663 3.33329V16.6666C4.16663 17.5871 4.91282 18.3333 5.83329 18.3333H14.1666C15.0871 18.3333 15.8333 17.5871 15.8333 16.6666V3.33329C15.8333 2.41282 15.0871 1.66663 14.1666 1.66663Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ai_chat_mini.tsx" />
      <path d="M10 15H10.0083" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ai_chat_mini.tsx" />
    </svg>;
};
export default AiChatMini;